import Big from 'big.js'

export const sumBy = <T>(
  array: ArrayLike<T> = [],
  iteratee: (value: T) => number | undefined = (value) => Number(value),
  precision?: number
): undefined | number => {
  let result
  let index = -1
  const { length } = array

  while (++index < length) {
    const current = iteratee(array[index])

    if (current !== undefined) {
      result =
        result === undefined
          ? current
          : Big(result)
              .plus(current)
              .round(precision || 5)
              .toNumber()
    } else {
      result = undefined
      break
    }
  }

  return result
}
